import settingsController from './settings.controller';

export default angular
  .module('st.Settings', ['ngPasswordMeter'])
  .controller('settingsController', settingsController);
